var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.344.245a.568.568 0 0 0-.699 0L.563 6.548l.699.884.988-.77v6.963a1.127 1.127 0 0 0 1.125 1.125h11.25a1.128 1.128 0 0 0 1.125-1.125V6.667l.988.77.7-.884L9.344.245Zm.781 13.38h-2.25v-4.5h2.25v4.5Zm1.125 0v-4.5A1.126 1.126 0 0 0 10.125 8h-2.25A1.126 1.126 0 0 0 6.75 9.125v4.5H3.375v-7.84L9 1.403l5.625 4.387v7.835H11.25Z",
    fill: "#6A2BE1"
  })));
};
var Memo = /*#__PURE__*/memo(SvgHome);
export default Memo;